export default function Socials({ assetsPath }) {
	//Social Icons
	const facebookIcon = `${EASYCOMMERCE.assets}admin/img/icons/facebook.png`;
	const twitterIcon = `${EASYCOMMERCE.assets}admin/img/icons/x.png`;
	const linkedinIcon = `${EASYCOMMERCE.assets}admin/img/icons/linkedin.png`;
	const youtubeIcon = `${EASYCOMMERCE.assets}admin/img/icons/youtube.png`;
	const socialIcon = `${EASYCOMMERCE.assets}admin/img/icons/social.png`;

	const socials = [
		{
			url: "https://www.facebook.com/groups/easycommerce.community",
			icon: socialIcon,
			alt: "Social",
		},
		{
			url: "https://x.com/easycommercedev/",
			icon: twitterIcon,
			alt: "Twitter",
		},
		{
			url: "https://www.linkedin.com/company/easycommercedev/",
			icon: linkedinIcon,
			alt: "Linkedin",
		},
		{
			url: "https://www.facebook.com/easycommercedev/",
			icon: facebookIcon,
			alt: "Facebook",
		},
		{
			url: "https://www.youtube.com/@EasyCommercedev",
			icon: youtubeIcon,
			alt: "Youtube",
		},
	];
	return (
		<>
			<ul className="flex items-center">
				{socials.map((social, index) => (
					<li key={index}>
						<a
							className="w-8 h-8 rounded-full bg-white flex items-center justify-center mx-2"
							href={social.url}
							target="_blank">
							<img src={social.icon} alt={social.alt} />
						</a>
					</li>
				))}
			</ul>
		</>
	);
}
